SA.Wootric = {
    accountToken: 'NPS-b5fa56bf',
    scriptSrc: 'https://disutgh7q0ncc.cloudfront.net/beacon.js',

    initialize() {
        if (window.env !== 'live') {
            return;
        }

        window.wootricSettings = this.getSettings();

        this.appendScript(() => window.wootric('run'));
    },

    appendScript(onLoad) {
        var script = document.createElement('script');

        script.onload = onLoad;
        script.src = this.scriptSrc;

        document.head.appendChild(script);
    },

    getSettings() {
        var user = SA.User,
            settings = {
                account_token: this.accountToken,
                properties: {
                    institution: SA.Institution.getName()
                }
            };

        if (!user.isGuest()) {
            settings.email = user.getUsername(); 
            settings.external_id = user.getId();
            settings.created_at = user.getFirstSessionOn();
        }

        return settings;
    }
};